import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import {isArray} from 'ngx-bootstrap/chronos';

@Directive({
    selector: '[appInvalidValueList]',
    providers: [{provide: NG_VALIDATORS, useExisting: InvalidValueListDirective, multi: true}]
})
export class InvalidValueListDirective implements Validator {
    @Input('appInvalidValueList') invalidValues: any[];

    validate(control: AbstractControl): ValidationErrors | null {
        if (isArray(control.value)) {
            // Explicitly cast control.value to any[] to ensure compatibility
            const invalidValues = (control.value as any[]).filter(value => this.invalidValues.includes(value));
            if (invalidValues.length > 0) {
                return {'invalidValue': invalidValues};
            }
            return null;
        }
        if (this.invalidValues.includes(control.value)) {
            return {'invalidValue': control.value};
        }
        return null;
    }
}
